import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  image: {
    borderWidth: 1,
    borderRadius: 100,
  },
  defaultImage: {
    borderWidth: 0,
    borderRadius: 100,
    width: 120,
    height: 120,
  },
  touchable: {
    justifyContent: 'center',
    marginBottom: 5,
    zIndex: 40,
  },
  button: {
    borderRadius: 50,
    borderWidth: 1,
    paddingVertical: 4,
    marginTop: -15,
    alignSelf: 'center',
  },
  text: {
    textAlign: 'center',
  },
  defaultBunchaBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: 1000,
    width: 120,
    height: 120,
  },
  starBadge: {
    position: 'absolute',
    bottom: -14,
    right: -14,
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 3,
    zIndex: 100,
    borderRadius: 20,
  },
  starIcon: {
    width: 16,
    height: 16,
  },
  imageBox: {
    position: 'relative',
    overflow: 'visible',
  },
});
